import {Application} from "@hotwired/stimulus"
import AccordionController from "./controllers/accordion_controller.js"

import {accordion} from "./js/accodion.js";
import {emblaReviews} from "./js/review-embla.js";
import {toc} from "./js/toc.js";
import {emblaSliders} from "./js/embla-sliders.js";
import {menu} from "./js/menu.js";
import {galleryTour} from "./js/gallery-tour.js";
import TourTabsController from "./controllers/tour_tabs_controller.js";


const application = Application.start()
application.register('accordion', AccordionController);
application.register('tour-tabs', TourTabsController);

document.addEventListener('DOMContentLoaded', () => {
    menu();
    accordion();
    emblaReviews();
    toc();
    emblaSliders();
    galleryTour();
});
